<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M1.875 14.25h14.25v1.5H1.875v-1.5Zm14.677-7.02c-.157-.6-.78-.96-1.38-.795L11.19 7.5 6.015 2.677l-1.447.383 3.105 5.377-3.728.998L2.467 8.28l-1.087.292 1.942 3.368L15.75 8.617a1.14 1.14 0 0 0 .802-1.387Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
